module.exports = __webpack_public_path__ + "static/img/海尔聪明风空调.2d3f142a.png";